import esLocale from 'element-ui/lib/locale/lang/es' //引入element语言包
const es = {
  Login: {
    ToLogin: 'Iniciar sesión',
    PhoneLogin: 'Número de teléfono móvil para iniciar sesión',
    EmailLogin: 'Inicio de sesión del buzón',
    PhonePlaceholder: 'Por favor, introduzca el número de teléfono móvil',
    EmailPlaceholder: 'Enter email',
    Code: 'Código de verificación',
    and: 'Y',
    BeforeText: 'Crear una cuenta al mismo tiempo significa que estás de acuerdo y cumples',
    UserAgreement: 'Protocolo de usuario',
    privacy: 'Política de privacidad',
    errorMessage: 'Error en el Código de verificación',
    readTitle: 'Leer y aceptar los siguientes acuerdos',
    readBefore: 'Para garantizar la seguridad de su información personal, lea y acepte primero',
    cancel: 'Cancelación',
    agree: 'Acordar y continuar',
    error1:'Introduzca una dirección de correo electrónico válida',
    error2:'Introduzca el número de teléfono correcto',
    error3:'Por favor, introduzca el Código de verificación',
    success:'Inicio de sesión exitoso'
  },
  ...esLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default es;
